import CreateNotificacionDto from '../../domain/CreateNotificacionDto'
import NotificacionAdapter from '../adapters/Notificacion.adapter'

export default class CreateNotificacionUsecase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  execute(notificacion) {
    try {
      const payload = NotificacionAdapter.toDto(notificacion, 'create')
      const notificacionCreated = this.#repository.create(payload)

      return notificacionCreated
    } catch {
      throw new Error('Error creating notification')
    }
  }
}
